module.exports = __webpack_public_path__ + "static/media/ios-battery-dead.4bfec6a4.svg";